import React, { useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Free from "../../assets/images/ui-love.svg";
import Premium from "../../assets/images/ui-crown.svg";

import global from "../../scss/dhp.scss";

let style = Object.assign({}, global);

const AssetInfo = ({ assetInfo }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  let type =
    assetInfo?.asset_type.charAt(assetInfo.asset_type.length - 1) === "s"
      ? assetInfo.asset_type.slice(0, -1)
      : assetInfo.asset_type;

  let stringWithoutUnderscores = type.replace(/_/g, " ");
  type = stringWithoutUnderscores.replace(/\b\w/g, match => match.toUpperCase());

  return (
    <div className={style["w-100"]}>
      <figure className={style["template-image"]}>
        <span className={style["mb-0"]}>
          <img className={style["img-fluid"]} onLoad={() => setIsImageLoaded(true)} src={assetInfo?.thumb} />
        </span>
      </figure>
      {isImageLoaded && (
        <div className={style["template-info"]}>
          <p className={cx(style["fw-7"], style["m-0"])}>{assetInfo?.category}</p>
          <div
            className={cx(
              style["d-flex"],
              style["align-items-center"],
              style["justify-content-center"],
              style["mb-3"],
              style["text-capitalize"]
            )}>
            <img src={assetInfo?.premium ? Premium : Free} width="20" className={style["mr-2"]} alt="" />{" "}
            {assetInfo?.premium ? "Premium" : "Free"} {type}
          </div>

          <span>
            Use this in a design now and share it with the world to get <br /> more likes, followers, and hearts.
          </span>
        </div>
      )}
    </div>
  );
};

AssetInfo.propTypes = {
  assetInfo: PropTypes.object.isRequired,
};

export default AssetInfo;
